// extracted by mini-css-extract-plugin
export var cardIcon = "_9m-4";
export var checkboxCard = "_9m-0";
export var checkboxCardSelected = "_9m-1";
export var disabled = "_9m-2";
export var outerBorder = "_9m-3";
export var spacerMedium = "_9m-7";
export var spacerSmall = "_9m-6";
export var spacerXsmall = "_9m-5";